import Styles from './VideoLoadingSpinner.module.scss'

interface Props {
  size?: number
  percentage?: number
}

export const VideoLoadingSpinner = ({ size = 24, percentage }: Props) => {
  return (
    <>
      <div className={Styles.loaderContainer}>
        <span className={Styles.loader} style={{ width: size, height: size }} />
      </div>
      {percentage !== undefined && <span className={Styles.percentage}>{Math.ceil(percentage)}%</span>}
    </>
  )
}
